export default "__VITE_ASSET__466a9b71__"